import React, { useState } from 'react';
import { View } from 'react-native';
import { isMacAppStore } from '@/lib/appDistribution';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';

export default function AppStoreCatalogStatus({ iap, credits = false }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const products = credits ? iap?.creditPackProducts : iap?.products;
  if (!isMacAppStore() || (products?.length && !iap?.error && !error)) return null;
  const reload = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try {
      if (!iap?.isConnected && !await iap?.connect()) throw new Error('The App Store is unavailable.');
      const result = await iap.fetchProducts();
      if (!(credits ? result?.creditPacks : result?.subscriptions)?.length) throw new Error('App Store prices are unavailable. Please try again.');
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return <View style={{ gap: 8, paddingVertical: 12 }}>
    <Text size="s" color="secondary" accessibilityRole="alert">{error || iap?.error || 'Loading App Store prices…'}</Text>
    <Button text="Reload App Store prices" variant="secondary" size="small" isLoading={busy} onPress={reload} />
  </View>;
}
